import * as firestore from 'firebase/firestore';
import { Employee } from '../types/Employee';

export default {
  toFirestore(employee: Employee): firestore.DocumentData {
    return employee;
  },
  fromFirestore(
    snapshot: firestore.QueryDocumentSnapshot
  ): Employee {
    const data = snapshot.data()!;
    return {
      type: data.type,
      uid: data.uid,
      idNumber: data.idNumber,
      name: data.name,
      iqamaNumber: data.iqamaNumber,
      passportNumber: data.passportNumber,
      nationality: data.nationality,
      occupation: data.occupation,
      dateHired: data.dateHired,
      department: data.department,
      salary: data.salary,
      chiefSupervisor: data.chiefSupervisor,
      supervisor: data.supervisor,
      phoneNumber: data.phoneNumber,
      lodge: data.lodge,
      picture: data.picture,
      status: data.status,
      metadata: data.metadata,
      taggedForDeletion: data.taggedForDeletion,
    };
  },
};
